<script>
import ModelEdit from '../models/edit';
import FormsModel from "@/components/forms/bank_account";

export default {
  extends: ModelEdit,
  page: {
    title: "Edit Bank Accounts",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('bank_accounts.singular')) }},
    resourceRoute: {default: 'bank_accounts'},
    modelVariable: {default: 'bank_account'},
    denyDelete : { type: Boolean, default: true },
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('bank_accounts.plural'))
    }
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.upperFirst(this.$t('bank_accounts.plural')),
          href: "/bank_accounts",
        },
        {
          text: this.model && this.model.id ? this.model['name'] : this.$route.params.key,
          href: `/bank_accounts/${this.$route.params.key}`,
          active: true,
        },
        {
          text: this.$t('Edit'),
          href: `/bank_accounts/${this.$route.params.key}/edit`,
          active: true,
        },
      ]
    }
  },
  methods: {
    fetchModel() {
      this.loading = true;
      this.$axios.get(`/bank_accounts/${this.$route.params.key}`, {
        params: {
          with: 'bank_accounts.bank'
        }
      }).then((response) => {
        const { data: { data } } = response;
        this.model = data;
        return response;
      }).catch((error) => this.failedAlert(error))
      .finally(() => this.loading = false)
    },
    update(value) {
      return this.$axios.put(`/bank_accounts/${this.$route.params.key}`, value)
    },
    delete() {
      return this.$axios.delete(`/bank_accounts/${this.$route.params.key}`)
    }
  }
}
</script>
